import { render, staticRenderFns } from "./LawActivityList.vue?vue&type=template&id=ff7e574c&"
import script from "./LawActivityList.vue?vue&type=script&lang=js&"
export * from "./LawActivityList.vue?vue&type=script&lang=js&"
import style0 from "./LawActivityList.vue?vue&type=style&index=0&id=ff7e574c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports